export const DEMO_TENANT = "demo";

export interface Snapshot {
  readonly today: string;
  readonly timeZone: string;
  readonly guildId: string;
  readonly reads: Readonly<Record<string, unknown>>;
}

export const readKey = (url: URL): string => {
  const params = [...url.searchParams].sort(([a, av], [b, bv]) =>
    a === b ? av.localeCompare(bv) : a.localeCompare(b),
  );
  const query = new URLSearchParams(params).toString();
  return query === "" ? url.pathname : `${url.pathname}?${query}`;
};
